export enum ReportSearchColumn {
  Unknown = "unknown",
  ProjectName = "projectName",
  ReportName = "reportName",
  AsOf = "asOf",
  LastRequested = "lastRequested",
  ProjectType = "projectType",
  Format = "format",
  ProviderCategory = "providerCategory",
  SpecialtyFilter = "specialtyFilter",
  Analysis = "analysis",
  Status = "status"
}